import * as logger from 'loglevel';
import { useEffect, useReducer } from 'react';
import { isNilOrEmpty } from '../../../helpers/utils';

const queryReducer = (state, action) => {
  switch (action.type) {
    case 'error': {
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    }
    case 'loading': {
      return {
        ...state,
        isLoading: true,
      };
    }
    case 'success': {
      return {
        ...state,
        isLoading: false,
        isError: false,
        data: isNilOrEmpty(action.payload) ? [] : action.payload,
      };
    }
    case 'retry': {
      return {
        ...state,
        retryFlag: !state.retryFlag,
      };
    }
    default: {
      return state;
    }
  }
};

export function useQuery({ getData, active = true }, deps = []) {
  const [{ isError, isLoading, data, retryFlag }, dispatch] = useReducer(queryReducer, {
    isError: false,
    isLoading: active,
    data: [],
    retryFlag: false,
  });

  useEffect(() => {
    if (!active) {
      return;
    }
    if (typeof getData !== 'function') {
      dispatch({ type: 'error' });
      logger.error(`PROMISE__USE_API: **getData** must be function.`);
    } else {
      dispatch({ type: 'loading' });
      getData()
        .then((response) => {
          dispatch({ type: 'success', payload: response });
        })
        .catch((err) => {
          dispatch({ type: 'error' });
          logger.error(err);
        });
    }
    // eslint-disable-next-line
  }, [retryFlag, active, ...deps]);

  const retry = () => dispatch({ type: 'retry' });

  return { isError, isLoading, data: active ? data : [], retry };
}
